<template>
  <div class="absolute no-drag">
    <div
      ref="modalRef"
      class="flex items-center opacity-70 text-14 group-hover:opacity-100 transition-color duration-300 py-5 px-10 rounded-8"
      :class="[
        {'opacity-100': menuIsOpen || isShowDropdown || show},
        !hasBookColor ? isDarkMode ? 'hover:bg-sidebar' : 'hover:bg-project' : '',
        show && !hasBookColor ? isDarkMode ? 'bg-sidebar' : 'bg-project' : ''
      ]"
      @click="showDropdown"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
    >
      <i class="icon-wysiwyg mr-5 text-15" :style="`color: ${bookColor?.main}`" />
      <p>{{ projects }}</p>
    </div>

    <InfoDropdown v-if="show" title="Pages" class="relative" classes="max-h-235 left-10" @show-dropdown="close">
      <div class="pb-8 px-12 overflow-y-auto">
        <div v-for="(project, index) in filteredProjects" :key="index" class="mb-4 text-15 flex items-center w-full">
          <div class="flex items-center w-full">
            <img v-if="project.icon" class="w-20 h-20 mr-10" :src="require(`@/assets/images/icons/${project.icon}.png`)" alt="icon">
            <img v-else-if="project.icon === null" class="w-20 h-20 mr-10" src="@/assets/images/icons/purple_circle.png" alt="icon">
            <p>{{ project.title }}</p>
          </div>
        </div>
      </div>
    </InfoDropdown>
  </div>
</template>

<script>
import InfoDropdown from '@/components/shared/InfoDropdown'
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  components: { InfoDropdown },

  props: {
    book: Object,
    bookColor: Object,
    projects: String,
    isShowDropdown: Boolean,
    menuIsOpen: Boolean
  },

  emits: ['showDropdown'],

  setup (props, { emit }) {
    const { getters, state } = useStore()

    const modalRef = ref(null)

    const show = ref(false)
    const isHover = ref(false)

    const hasBookColor = computed(() => props.bookColor?.main)

    const currentMember = computed(() => state.team.member)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isMagenta = computed(() => getters.isMagenta)
    const isDraculaTheme = computed(() => state.settings.settings.theme === 'Dracula')
    const isPoseidonTheme = computed(() => state.settings.settings.theme === 'Poseidon')

    const filteredProjects = computed(() => props.book.projects.filter(item => !item.parentId).sort((a, b) => {
      if (a.order > b.order) return 1
      if (a.order < b.order) return -1
      if (a.createdAt > b.createdAt) return 1
      if (a.createdAt < b.createdAt) return -1
      return 0
    }))

    function showDropdown () {
      setTimeout(() => {
        show.value = true
        emit('showDropdown', true)
      }, 100)
    }

    function close () {
      show.value = false
      modalRef.value.style = ''
      emit('showDropdown', false)
    }

    function mouseenter (e) {
      if (hasBookColor.value) {
        modalRef.value.style = `background-color: ${props.bookColor.accent}; filter: brightness(0.93);`
      }
    }

    function mouseleave (e) {
      if (hasBookColor.value && !show.value) {
        modalRef.value.style = ''
      }
    }

    return {
      // refs
      modalRef,
      // data
      isHover,
      show,
      // computeds
      isPoseidonTheme,
      filteredProjects,
      isDraculaTheme,
      currentMember,
      hasBookColor,
      isDarkMode,
      isMagenta,
      // functions
      close,
      showDropdown,
      mouseenter,
      mouseleave
    }
  }
})
</script>
